/** @format */

import React, { useMemo } from "react";
import {
  EmbeddedCheckout,
  EmbeddedCheckoutProvider,
} from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";

const stripePromiseCache = new Map();

const getStripePromise = (publishableKey) => {
  if (!stripePromiseCache.has(publishableKey)) {
    stripePromiseCache.set(publishableKey, loadStripe(publishableKey));
  }

  return stripePromiseCache.get(publishableKey);
};

const StripeEmbeddedCheckout = ({
  publishableKey,
  clientSecret,
  onComplete,
}) => {
  const stripePromise = useMemo(() => {
    if (!publishableKey) {
      return null;
    }

    return getStripePromise(publishableKey);
  }, [publishableKey]);

  const options = useMemo(
    () => ({
      clientSecret,
      onComplete,
    }),
    [clientSecret, onComplete]
  );

  if (!publishableKey || !clientSecret) {
    return null;
  }

  return (
    <EmbeddedCheckoutProvider options={options} stripe={stripePromise}>
      <EmbeddedCheckout />
    </EmbeddedCheckoutProvider>
  );
};

export default StripeEmbeddedCheckout;
